import React from "react";
import { CreateVariantChildFormValues } from "./types";

export type CreateVariantChildFormFormContextType = {
  handleOnSubmit: (values: CreateVariantChildFormValues) => Promise<void>;
};

export const CreateVariantChildFormFormContext = React.createContext<
  CreateVariantChildFormFormContextType | undefined
>(undefined);
